import { render, staticRenderFns } from "./CreateQuestionDialog.vue?vue&type=template&id=16ecaeb6&scoped=true"
import script from "./CreateQuestionDialog.vue?vue&type=script&lang=js"
export * from "./CreateQuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateQuestionDialog.vue?vue&type=style&index=0&id=16ecaeb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ecaeb6",
  null
  
)

export default component.exports